import { answerEnglishIqV1Api } from '@repo/sdk';
import { requireEnglishIqResponseData } from './require-english-iq-response-data';

export async function answerEnglishIqWebSession(itemId: string, choice: string, token: string) {
  const response = await answerEnglishIqV1Api({ choice, itemId, token });
  return requireEnglishIqResponseData(response.data.data);
}
